module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('part-item', {
    attrs: {
      "title": _vm.$t('hotGames')
    }
  }, [_c('div', {
    staticClass: "refresh",
    on: {
      "click": _vm.shuffleGames
    },
    slot: "header-right"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('changeGames'))), _c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "hot-games"
  }, _vm._l((_vm.currentGames), function(game, index) {
    return _c('div', {
      key: index,
      staticClass: "hot-game"
    }, [_c('div', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy:background-image",
        value: (game.hot_game_pic_url),
        expression: "game.hot_game_pic_url",
        arg: "background-image"
      }],
      staticClass: "top-bg",
      on: {
        "click": function($event) {
          _vm.openWeb(game.detail_href)
        }
      }
    }, [_c('div', {
      staticClass: "game-qr"
    }, [_c('div', {
      staticClass: "qr-container"
    }, [_c('img', {
      staticClass: "qr",
      attrs: {
        "src": game.code_pic_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "right-desc"
    }, [_c('p', [_vm._v(_vm._s(_vm.$t('gameType')) + "：" + _vm._s(game.type))]), _vm._v(" "), _c('div', {
      staticClass: "rating"
    }, [_c('p', [_vm._v(_vm._s(_vm.$t('gameRating')) + "：")]), _vm._v(" "), _c('div', {
      staticClass: "stars"
    }, _vm._l((5), function(i) {
      return _c('i', {
        staticClass: "fa fa-star"
      })
    }))])])])])]), _vm._v(" "), _c('div', {
      staticClass: "bottom-desc"
    }, [_c('h3', {
      staticClass: "game-title"
    }, [_vm._v(_vm._s(game.app_name))]), _vm._v(" "), _c('p', {
      staticClass: "game-desc"
    }, [_vm._v(_vm._s(game.big_title))]), _vm._v(" "), _c('div', {
      staticClass: "links"
    }, [_c('a', {
      staticClass: "link-btn",
      attrs: {
        "href": game.detail_href,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(_vm.$t('goToSite')))])])])])
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-43bba9cf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/HotGames.vue
// module id = 374
// module chunks = 1